function generateUrl(location: Location): string {
  let url = `${location.protocol}//${location.host}/api/`;
  if(url.includes('.guai-dev.diaple.com')) {
    url = url.replace('.guai-dev.diaple.com', '.api.guai-dev.diaple.com');
  } else if(url.includes('.erp-dev.guainsurtech.com')) {
    url = url.replace('.erp-dev.guainsurtech.com', '.api.erp-dev.guainsurtech.com');
  }
  return url;
}
function getCookieDomain(location: Location): string {
  let domain = location.hostname;
  if(domain.includes('.guai-dev.diaple.com')) {
    return '.guai-dev.diaple.com';
  } else if(domain.includes('.erp-dev.guainsurtech.com')) {
    return '.erp-dev.guainsurtech.com';
  }
  return '';
}
export const environment = {
    production: false,
    api_gw: generateUrl(location),
    cookie_domain: getCookieDomain(location),
    google_maps: {
      api_key: 'AIzaSyBQ6R0ztV8tRPGYLT26j5rsDD2QVkzWLsM'
    },
    mqtt: {
      server: 'dev-02.diaple.com',
      port: 8080,
      protocol: "wss", //ws, wss
      username: "admin",
      password: "su2xu1"
    },
    pbx: {
      server: 'dev-02.diaple.com',
      port: 5060
    }
};  
